// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 1C9.51472 1 7.5 3.01472 7.5 5.5V7H3V23H21V7H16.5V5.5C16.5 3.01472 14.4853 1 12 1ZM14.5 5.5V7H9.5V5.5C9.5 4.11929 10.6193 3 12 3C13.3807 3 14.5 4.11929 14.5 5.5ZM7.5 12V9H9.5V12H7.5ZM14.5 12V9H16.5V12H14.5Z"}}]};

const ShopFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'shop-filled',
    ref,
    icon: element,
  },
));

ShopFilledIcon.displayName = 'ShopFilledIcon';

export default ShopFilledIcon;
